module.exports = __webpack_public_path__ + "img/kidney.63ee5a53.svg";